import { ErrorMessage, useFormContext } from "@fluidattacks/design";

import type { IAffectedAccordionProps } from "./types";
import { VulnerabilitiesToReattackTable } from "./vulnerabilities-to-reattack-table";

import type { IFormValues } from "../add-modal";

const AffectedReattackAccordion = ({
  findings,
}: IAffectedAccordionProps): JSX.Element => {
  const { formState } = useFormContext<IFormValues>();

  const panelOptions = findings.map((finding): JSX.Element => {
    return (
      <VulnerabilitiesToReattackTable finding={finding} key={finding.id} />
    );
  });

  return (
    <div>
      {panelOptions}
      <ErrorMessage $show={true}>
        {formState.errors.affectedReattacks?.message?.toString()}
      </ErrorMessage>
    </div>
  );
};

export { AffectedReattackAccordion };
